export default "/images/twitter.svg?f9468adeb9625d9ea86a028471de21a4";